import React from 'react';
import { motion } from 'framer-motion';
import '../styles/PageLoader.css';

const PageLoader = () => {
  return (
    <motion.div 
      className="page-loader"
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 1, delay: 0.5 }}
      exit={{ opacity: 0 }}
    >
      <div className="loader-content">
        <motion.div
          className="loader-circle"
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 360],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.span
          className="loader-text"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          Chargement...
        </motion.span>
      </div>
    </motion.div>
  );
};

export default PageLoader;
